import { Form } from '@framework'

export default {
    data() {
        let form = new Form({
            username: '',
            password: '',
            remember: false,
            captcha: ''
        }, ($, rules) => {
            return rules(
                $('username', 'password').required(false, {errorMessage: (target) => `Please enter a ${target.toLowerCase()}`}),
                $('captcha').required(false, {errorMessage: (target) => `Please enter a ${target.toLowerCase()}`}).when(() => this.loginAttempts >= this.captchaOnLoginAttempts)
            )
        }, {
            captcha: 'Verification Code'
        })

        return {
            passwordComponent: 'oc-password-input',
            passwordIcon: 'glyphicon-eye-open',
            formGlobalErrorMessage: '',
            formErrorMessage: 'We found some errors. Please review the form and make corrections.',
            formFieldErrors: {},
            loginAttempts: _appConfig.loginAttempts,
            form
        }
    },
    computed: {
        loading() {
            return this.$store.getters['auth/isLoading']
        },
        captchaImageURL() {
            return _appConfig.captchaImageURL
        },
        captchaOnLoginAttempts() {
            return _appConfig.captchaOnLoginAttempts
        },
        hasFormErrors() {
            return this.formGlobalErrorMessage.length > 0 || (this.formErrorMessage.length > 0 && this.form.validator().errors().any())
        }
    },
    methods: {
        showPassword(e) {
            this.passwordIcon = 'glyphicon-eye-close'
            this.passwordComponent = 'oc-text-input'
        },
        hidePassword(e) {
            this.passwordIcon = 'glyphicon-eye-open'
            this.passwordComponent = 'oc-password-input'
        },
        doSignIn(e) {
            this.$store.commit('auth/LOADING', true)

            this.form.validate().then( result => {
                if( ! result.valid ) {
                    this.$store.commit('auth/LOADING', false)
                    return false
                }

                this.formGlobalErrorMessage = '' // reset

                let formData = this.form.getData()

                let method = {
                    method: 'sign-in',
                    s: _appConfig.authState.session,
                    client: _appConfig.client,
                    embed: _appConfig.embed
                }

                API.POST('login', method, formData, {onErrorNotifyCallback: () => {}}).then( response => {

                    this.loginAttempts = 0

                    // the rest will be handled by AuthHelper.handleSpecialResponse
                }).catch(e => {
                    this.$store.commit('auth/LOADING', false)
                    this.formFieldErrors = {}

                    if ( ! e.response ) {
                        this.formGlobalErrorMessage = 'Internal server error. Please contact your vendor.'
                        return
                    }

                    if( e.response.getStatus() !== e.response.constructor.STATUS_VALIDATION_ERROR ) {
                        this.formGlobalErrorMessage = e.response.getMessage() || ''

                        this.$nextTick(() => {
                            if( this.$refs.captcha ) {
                                this.$refs.captcha.refreshCaptcha()
                            }
                        })

                        return
                    }

                    let formErrors = e.response.getErrors()

                    this.loginAttempts = formErrors.loginAttempts
                    delete formErrors.loginAttempts

                    if( this.loginAttempts >= this.captchaOnLoginAttempts && formErrors.captcha === undefined ) {
                        // https://github.com/yiisoft/yii2/blob/master/framework/captcha/CaptchaValidator.php#L20
                        // captcha validation was successful
                        // so we need to refresh it
                        this.$nextTick(() => {
                            if( this.$refs.captcha ) {
                                this.$refs.captcha.refreshCaptcha()
                            }
                        })
                    }

                    for ( let field in formErrors ) {
                        let message = formErrors[field]

                        if( field === 'globalErrors' ) {
                            this.formGlobalErrorMessage = message
                            continue
                        }

                        Vue.set(this.formFieldErrors, field, message)
                        this.form.addError(field, message)
                    }
                })
            })

            return false
        }
    }
}
